<template>
  <b-modal
    ref="modalAddBrigade"
    v-model="isSidebarActive"
    size="lg"
    hide-header
    hide-footer
    no-close-on-esc
    no-close-on-backdrop
    centered
    @shown="loadData"
    @hidden="resetModal"
  >
    <div>
      <div class="d-flex justify-content-between align-items-center py-1">
        <h5 class="mb-0 text-capitalize">
          {{ isAdd ? `${$t("actions.add")} ${$tc("brigades.title", 1)}` : `${$t("actions.edit")} ${$tc("brigades.title", 1)}` }}
        </h5>
      </div>

      <hr />

      <b-row>
        <b-col md="4">
          <b-row>
            <b-col md="12">
              <b-form-group :label="$tc('unit.title', 1)">
                <!--<select-paginate
                  v-model="itemData.unit_id"
                  :items="unitOptions"
                  input-id="id_unit"
                  :reduce="(unit) => unit.value"
                  :disabled="!isAdd || isReadOnly"
                />-->
                <v-select
                  v-model="itemData.unit_id"
                  :options="unitOptions"
                  :get-option-label="getUnitLabel"
                  :reduce="(unit) => unit.value"
                  :clearable="true"
                  :disabled="!isAdd || isReadOnly"
                />

              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="12">
              <b-form-group :label="$t('brigades.floor')">
                <v-select
                  v-model="itemData.floor_id"
                  :options="floorsOptions"
                  label="label"
                  :reduce="(option) => option.value"
                  @input="selectFloor"
                  :disabled="isReadOnly"
                />
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="6"><strong>{{$t('brigades.type_category')}}:</strong></b-col>
            <b-col cols="6">{{ unit && unit.category ? unit.category : "" }}</b-col>
          </b-row>

          <b-row>
            <b-col cols="6"><strong>{{$t('brigades.number_floors')}}:</strong></b-col>
            <b-col cols="6">{{
              unit && unit.floor_number ? unit.floor_number : ""
            }}</b-col>
          </b-row>

          <b-row>
            <b-col cols="6"><strong>REMS:</strong></b-col>
            <b-col cols="6">{{ unit && unit.rems ? unit.rems : "" }}</b-col>
          </b-row>

          <b-row>
            <b-col cols="6"><strong>SIRH:</strong></b-col>
            <b-col cols="6">{{ unit && unit.sirh ? unit.sirh : "" }}</b-col>
          </b-row>

          <b-row>
            <b-col cols="6"><strong>{{$t('brigades.capacity')}}:</strong></b-col>
            <b-col cols="6">{{ headcount }}</b-col>
          </b-row>
        </b-col>

        <b-col md="8">
          <b-row>
            <b-col md="12">
              <b-form-group :label="$t('brigades.role')">
                <v-select
                  v-model="form.rol"
                  :options="brigadeRolesOptions"
                  label="label"
                  :disabled="isReadOnly"
                />
              </b-form-group>
            </b-col>

            <!-- <b-col md="12">
              <b-form-group :label="$t('brigades.user')">
                <v-select
                  v-model="form.usuario"
                  :options="localBrigadeUsersOptions"
                  label="label"
                  :disabled="isReadOnly"
                />
              </b-form-group>
            </b-col> -->
            
            <b-col md="12">
              <b-form-group
                class="text-capitalize"
                :label="$tc('brigades.user')"
                label-for="user"
              >
                <base-select-pagination
                  url="/v1/users-rh"
                  input-id="user"
                  v-model="form.usuario"
                  :option-mapper="userMapperOption"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="4"></b-col>

        <b-col md="8" class="text-right mb-1">
          <b-button size="sm" variant="outline-primary" @click="addBrigadier" :disabled="isReadOnly">
            {{ editingIndex != null ? "Editar Brigadista" : "Agregar Brigadista" }}
          </b-button>
        </b-col>
      </b-row>

      <b-row class="mb-2">
        <b-col md="4" class="d-flex align-items-center">
          <label class="mb-0 mr-2">{{$t('brigades.filter_by_floor')}}:</label>
          <v-select
            v-model="floorFilter"
            :options="floorsOptions"
            label="label"
            :reduce="(option) => option.value"
            clearable
            style="min-width: 150px"
          />
        </b-col>
        <b-col md="4" class="d-flex align-items-center">
          <label class="mb-0 mr-2">{{$t('brigades.filter_by_role')}}:</label>
          <v-select
            v-model="roleFilter"
            :options="['FSO', 'SA', 'FW']"
            label="label"
            clearable
            style="min-width: 150px"
          />
        </b-col>
        <b-col md="4" class="d-flex align-items-center">
          <label class="mb-0 mr-2">{{$t('brigades.filter_by_search')}}:</label>
          <b-form-input
            :placeholder="$t('brigades.filter_by_search_placeholder')"
            v-model="searchFilter"
            trim
          />
        </b-col>
      </b-row>

      <!-- TABLA ASIGNACIONES -->
      <b-table small bordered responsive :items="filteredBrigadistas" :fields="fields">
        <template #cell(rol)="data">
          {{
            data.item.rol && data.item.rol.label
              ? data.item.rol.label
              : data.item.rol || ""
          }}
        </template>

        <template #cell(user)="data">
          {{
            data.item.user && data.item.user.label
              ? data.item.user.label
              : data.item.user || ""
          }}
        </template>

        <template #cell(floor)="data">
          {{
            data.item.floor && data.item.floor.floor_number
              ? data.item.floor.floor_number
              : data.item.floor || ""
          }}
        </template>

        <template #cell(floor.active)="data">
          <span v-if="data.item">
            {{ $t("pisos.active") }}
          </span>
          <span v-else>
            {{ $t("pisos.inactive") }}
          </span>
        </template>

        <template #cell(accion)="row">
          <div class="d-flex gap-1">
            <!--<b-button
            size="sm"
            variant="link"
            v-b-tooltip.hover
            :title="$t('actions.edit')"
            @click="editBrigadier(row.index)"
          >
            <feather-icon size="16" icon="EditIcon" />
          </b-button>-->
            <b-button
              size="sm"
              variant="link"
              v-b-tooltip.hover
              :title="$t('actions.delete')"
              @click="removeBrigadier(row.index)"
              :disabled="isReadOnly"
            >
              <feather-icon size="16" icon="TrashIcon" />
            </b-button>
          </div>
        </template>
      </b-table>

      <b-col cols="12">
        <b-form-group label="Archivos" label-for="section_attachments">
          <div
            class="file-upload-info-box attachments-info mb-2"
            v-b-tooltip.hover.html
            title="PDF, Excel, EML"
          >
            <feather-icon icon="InfoIcon" size="14" class="info-icon" />
            <small class="file-upload-info-text">
              <strong>{{ $t("actions.file_upload.accepted_types_label") }}</strong>
              {{ "(PDF, Excel, EML)" }}
              <strong>{{ $t("actions.file_upload.max_label") }}</strong>
              {{ $t("actions.file_upload.max_per_document") }}
              -
              {{ $t("actions.file_upload.max_documents_total") }}
            </small>
          </div>
          <div v-if="true" class="d-flex align-items-center flex-wrap gap-2 mb-2">
            <b-button
              variant="primary"
              size="sm"
              :disabled="
                form.section_attachments &&
                form.section_attachments.length >= maxSectionAttachments || isReadOnly
              "
              class="attachments-upload-btn"
            >
              <feather-icon icon="UploadIcon" size="18" />
              <input
                ref="sectionAttachmentsInputRef"
                type="file"
                multiple
                accept=".pdf,.xls,.xlsx,.eml"
                class="file-input-hidden"
                @change="handleSectionAttachmentChange"
                :disabled="isReadOnly"
              />
            </b-button>
          </div>
          <ul
            v-if="form.section_attachments && form.section_attachments.length"
            class="attachments-list list-unstyled mt-2 mb-0"
          >
            <li
              v-for="(att, index) in form.section_attachments"
              :key="'section-' + index"
              class="attachment-item d-flex align-items-center justify-content-between py-2 px-2 mb-1 rounded border"
            >
              <span
                class="attachment-preview flex-grow-1 text-truncate cursor-pointer"
                @click="onSectionAttachmentClick(att)"
              >
                <feather-icon icon="FileTextIcon" size="16" class="mr-1 align-middle" />
                {{ att.name || "-" }}
                <small v-if="att.raw" class="text-muted ml-1"
                  >({{ $t("policy_exception.pending_save") }})</small
                >
              </span>
              <b-button
                v-if="true"
                variant="danger"
                size="sm"
                class="btn-icon btn-sm ml-1"
                @click.stop="removeSectionAttachment(index)"
                :disabled="isReadOnly"
              >
                <feather-icon icon="XIcon" size="14" />
              </b-button>
            </li>
          </ul>
        </b-form-group>
      </b-col>

      <hr />

      <div class="text-right">
        <b-button
          variant="secondary"
          class="mr-1 btn-sm"
          @click="$emit('update:isSidebarActive', false)"
        >
          {{ $t("actions.cancel") }}
        </b-button>

        <b-button
          variant="primary"
          class="btn-sm"
          @click="onSubmit"
          :disabled="isSubmitDisabled"
        >
          {{ $t("actions.save") }}
        </b-button>
      </div>
    </div>
  </b-modal>
</template>
<script>
import {
  BSidebar,
  BForm,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BButton,
  BFormCheckbox,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import vSelect from "vue-select";
import { ref, computed, watch } from "@vue/composition-api";
import { required, alphaNum, email, positive } from "@validations";
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import formValidation from "@core/comp-functions/forms/form-validation";
import Ripple from "vue-ripple-directive";
import store from "@/store";
import SelectPaginate from "../components/SelectPaginate.vue";
import i18n from "@/libs/i18n";
import { deburr, toLower } from "lodash";
import BaseSelectPagination from "@/components/Form/BaseSelectPagination.vue";

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    vSelect,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    SelectPaginate,
    ToastificationContent,
    BaseSelectPagination,
  },
  directives: {
    Ripple,
  },
  model: {
    prop: "isSidebarActive",
    event: "update:isSidebarActive",
  },
  props: {
    isSidebarActive: { type: Boolean, required: true },
    itemEdit: { type: Object, required: false },
    unitOptions: { type: Array, required: true },
    isAdd: { type: Boolean, required: true },
    brigadeUsersOptions: { type: Array, required: true },
    brigadeUsersFilter: { type: Array, required: false },
    brigadeRolesOptions: { type: Array, required: true },
    brigadeRolesFilter: { type: Array, required: false },
    brigadeStatusOptions: { type: Array, required: true },
    brigadeStatusFilter: { type: Array, required: false },
    isReadOnly: { type: Boolean, required: false },
  },
  data() {
    return {
      required,
      alphaNum,
      email,
      positive,
    };
  },
  setup(props, { emit }) {
    const toast = useToast();
    const brigadistas = ref([]);
    const editingIndex = ref(null);
    const tiposCapacitacion = ref(["Online", "Offline", "Presencial"]);
    const headcount = ref(null);
    const initialSectionAttachmentsSignature = ref("[]");
    const form = ref({
      rol: null,
      usuario: null,
      fechaCapacitacion: null,
      tipoCapacitacion: null,
      section_attachments: null,
    });
    const fields = ref([
      { key: "rol", label: "Rol" },
      { key: "user", label: "Usuario" },
      { key: "soeid", label: "soeid" },
      { key: "floor", label: "Piso" },
      { key: "floor.active", label: "Estatus Piso" },
      { key: "assignment_date", label: "Fecha Asignación" },
      { key: "assignment_status", label: "Estatus Asignación" },
      { key: "training_date", label: "Fecha Capacitación" },
      { key: "training_type", label: "Tipo Capacitación" },
      { key: "training_status", label: "Estatus Capacitación" },
      { key: "accion", label: "Acción" },
    ]);
    const blankData = {
      unit_id: null,
      floor_id: null,
      brigadistas: [],
    };
    const submitDisabled = ref(false);
    const itemData = ref(JSON.parse(JSON.stringify(blankData)));
    const localBrigadeUsersOptions = ref([]);

    const roleFilter = ref(null);
    const floorFilter = ref(null);
    const searchFilter = ref(null);

    const normalizeString = (str) => toLower(deburr(str.trim()));

    const filteredBrigadistas = computed(() => {
      let result = brigadistas.value;

      if (roleFilter.value) {
        result = result.filter((b) => b.rol?.code === roleFilter.value);
      }

      if (floorFilter.value) {
        result = result.filter((b) => b.floor?.id === floorFilter.value);
      }

      if (searchFilter.value) {
        result = result.filter((b) => {
          const searchNormalized = normalizeString(searchFilter.value);

          const userMatches = normalizeString(b.user?.label).includes(searchNormalized);
          const soeidMatches = normalizeString(b.soeid).includes(searchNormalized);

          return userMatches || soeidMatches;
        });
      }

      return result.sort((a, b) => a.floor.floor_number - b.floor.floor_number);
    });

    const unit = computed(() => {
      return props.unitOptions.find((u) => u.value === itemData.value.unit_id) || null;
    });

    const floorsOptions = computed(() => {
      if (!unit.value?.floors?.length) {
        return [];
      }

      const uniqueFloors = unit.value.floors
        .filter(f => f.headcount > 0 && f.is_occupied === true)
        .filter((f, index, self) => index === self.findIndex((x) => x.id === f.id))
        .sort((a, b) => a.floor_number - b.floor_number);

      return uniqueFloors.map((f) => ({
        label: `Piso ${f.floor_number}`,
        value: f.id,
      }));
    });

    const brigadeModified = ref(false);

    const hasBrigadeChanges = computed(() => {
      return brigadeModified.value;
    });

    const isSubmitDisabled = computed(() => {
      if (props.isAdd) return !hasValidBaseFields.value;
      //fix: brigade sections
      if (hasBrigadeChanges.value || hasSectionAttachmentChanges.value) return false;
      return true;
    });

    watch(
      () => props.brigadeUsersOptions,
      (newVal) => {
        localBrigadeUsersOptions.value = [...newVal];
      },
      { immediate: true }
    );

    watch(
      () => itemData.value.unit_id,
      (newUnitId) => {
        headcount.value = null;
        itemData.value.floor_id = null;

        if (!newUnitId) return;

        const isEdit = !props.isAdd && props.itemEdit;
        const isSameUnit = isEdit && props.itemEdit.id_unit === newUnitId;

        const selectedUnit = props.unitOptions.find((u) => u.value === newUnitId);
        if (selectedUnit?.hasBrigadeAssigned && !isSameUnit) {
          toast({
            component: ToastificationContent,
            props: {
              title: `La unidad "${selectedUnit.label}" ya tiene una brigada asignada.`,
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
          itemData.value.unit_id = null;
        }
      }
    );

    const selectFloor = (selectedId) => {
      headcount.value = null;
      if (!unit.value?.floors?.length) {
        return [];
      }

      const floor = unit.value.floors.find((f) => f.id === selectedId);
      if (floor) {
        headcount.value = floor.headcount;
      }
    };

    const editBrigadier = (index) => {
      const brigadier = brigadistas.value[index];
      form.value.rol = brigadier.rol;
      form.value.usuario = brigadier.usuario;
      form.value.fechaCapacitacion = brigadier.fechaCapacitacion;
      form.value.tipoCapacitacion = brigadier.tipoCapacitacion;
      editingIndex.value = index;
    };

    // Agregar / Editar
    const addBrigadier = () => {
      const unitId = itemData.value.unit_id;
      const floorId = itemData.value.floor_id;
      const rol = form.value.rol;
      const user = form.value.usuario;
      if (!unitId || !floorId || !rol || !user) {
        toast({
          component: ToastificationContent,
          props: {
            title: "Completa todos los campos requeridos",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
        return;
      }

      const floor = unit.value.floors.find((f) => f.id === floorId);
      const branchType = unit.value?.category || "";
      let canAdd = true;
      if (branchType.toLowerCase().includes("sucursal")) {
        canAdd = validateRolSucursal(rol, brigadistas.value, form.value);
      } else {
        canAdd = validateRolesBuilding(rol, brigadistas.value, form.value);
      }
      if (!canAdd) {
        return;
      }

      const soeid = user.soeid;
      const [fullName = ""] = (user.label || "").split(" | ");
      const userRh = {
        value: user.value,
        label: fullName.trim(),
      };
      const assignment_date =
        form.value.usuario.assignment_date ?? new Date().toISOString().split("T")[0];
      const assignment_status = form.value.usuario.assignment_status ?? "Vigente";

      const sameRole = rol?.code === user?.code_role;

      let training_date = null;
      let training_type = null;
      let training_status = "Sin capacitación";

      if (sameRole) {
        training_date = user.training_date ? user.training_date.split(" ")[0] : null;
        training_type = user.training_type;
        training_status = user.training_status;
      }

      const brigadierNew = {
        rol: rol,
        user: userRh,
        floor: floor,
        soeid: soeid,
        assignment_date: assignment_date,
        assignment_status: assignment_status,
        training_date: training_date,
        training_type: training_type,
        training_status: training_status,
      };

      if (editingIndex.value !== null) {
        brigadistas.value[editingIndex.value] = brigadierNew;
        editingIndex.value = null;
      } else {
        brigadistas.value.push(brigadierNew);
      }

      brigadeModified.value = true;

      resetForm();
    };

    const resetForm = () => {
      form.value.rol = null;
      form.value.usuario = null;
      form.value.fechaCapacitacion = null;
      form.value.tipoCapacitacion = null;
      //form.value.section_attachments = null;
    };

    const removeBrigadier = (index) => {
      //const removed = brigadistas.value[index];
      //brigadistas.value.splice(index, 1);
      const brigadierFiltered = filteredBrigadistas.value[index];
      if (!brigadierFiltered) return;

      const realIndex = brigadistas.value.findIndex((b) => b === brigadierFiltered);
      if (realIndex === -1) return;

      const removed = brigadistas.value.splice(realIndex, 1)[0];

      if (!removed || !removed.user) return;

      const exists = localBrigadeUsersOptions.value.some(
        (u) => u.value === removed.user.value
      );

      if (!exists) {
        localBrigadeUsersOptions.value.push({
          value: removed.user.value,
          label: removed.user.label + " | " + removed.soeid,

          soeid: removed?.soeid ?? null,
          code_role: removed?.rol?.code ?? null,
          name_role: removed?.rol?.label ?? null,
          assignment_date: removed?.assignment_date ?? null,
          assignment_status: removed?.assignment_status ?? null,
          training_date: removed?.training_date ?? null,
          training_type: removed?.training_type ?? null,
          training_status: removed?.training_status ?? null,
        });

        localBrigadeUsersOptions.value.sort((a, b) => a.label.localeCompare(b.label));
      }

      brigadeModified.value = true;
    };

    const validateRolSucursal = (rol, brigadistasList, form) => {
      if (!rol) return true;

      const rolCode = rol.code;
      const rolLabel = rol.label;

      // Evitar duplicados del mismo rol
      const alreadyExists = brigadistasList.some((b) => b.rol?.code === rolCode);
      if (alreadyExists) {
        toast({
          component: ToastificationContent,
          props: {
            title: `El rol "${rolLabel}" ya fue asignado`,
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
        return false;
      }

      // Lista temporal para validar FW/FSO/SA
      const tempList = [...brigadistasList, { rol, usuario: form.usuario }];

      const fw = tempList.find((b) => b.rol?.code === "FW");
      const fso = tempList.find((b) => b.rol?.code === "FSO");
      const sa = tempList.find((b) => b.rol?.code === "SA");

      // FW debe ser diferente a FSO/SA
      if (
        rolCode === "FW" &&
        ((fso && form.usuario.value === fso.user.value) ||
          (sa && form.usuario.value === sa.user.value))
      ) {
        toast({
          component: ToastificationContent,
          props: {
            title: "FW debe ser una persona distinta a FSO/SA",
            variant: "danger",
          },
        });
        return false;
      }

      // SA debe ser la misma persona que FSO
      if (rolCode === "SA" && fso && form.usuario.value !== fso.user.value) {
        toast({
          component: ToastificationContent,
          props: {
            title: "SA debe ser la misma persona que FSO",
            variant: "danger",
          },
        });
        return false;
      }

      // FSO debe ser la misma persona que SA
      if (rolCode === "FSO" && sa && form.usuario.value !== sa.user.value) {
        toast({
          component: ToastificationContent,
          props: {
            title: "FSO debe ser la misma persona que SA",
            variant: "danger",
          },
        });
        return false;
      }

      return true;
    };

    const validateRolesBuilding = (rol, brigadistasList, form) => {
      if (!rol) return true;

      const rolCode = rol.code;
      const rolLabel = rol.label;
      const userId = form.usuario.value;

      // Evitar duplicados de rol por usuario
      const alreadyExists = brigadistasList.some(
        (b) => b.rol?.code === rolCode && b.user.value === userId
      );
      if (alreadyExists) {
        toast({
          component: ToastificationContent,
          props: {
            title: `El rol "${rolLabel}" ya fue asignado a esta persona`,
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
        return false;
      }

      // FSO y SA deben ser la misma persona uno por inmueble
      const fso = brigadistasList.find((b) => b.rol?.code === "FSO");
      const sa = brigadistasList.find((b) => b.rol?.code === "SA");

      if (rolCode === "FSO" && sa && sa.user.value !== userId) {
        toast({
          component: ToastificationContent,
          props: {
            title: "FSO debe ser la misma persona que SA",
            variant: "danger",
          },
        });
        return false;
      }

      if (rolCode === "SA" && fso && fso.user.value !== userId) {
        toast({
          component: ToastificationContent,
          props: {
            title: "SA debe ser la misma persona que FSO",
            variant: "danger",
          },
        });
        return false;
      }

      // Solo 1 FSO y 1 SA por inmueble
      if ((rolCode === "FSO" && fso) || (rolCode === "SA" && sa)) {
        toast({
          component: ToastificationContent,
          props: {
            title: `Ya existe un ${rolCode} asignado para este inmueble`,
            variant: "danger",
          },
        });
        return false;
      }

      if (
        rolCode === "FW" &&
        ((fso && form.usuario.value === fso.user.value) ||
          (sa && form.usuario.value === sa.user.value))
      ) {
        toast({
          component: ToastificationContent,
          props: {
            title: "FW debe ser una persona distinta a FSO/SA",
            variant: "danger",
          },
        });
        return false;
      }

      return true;
    };

    function normalizeAttachments(attachments) {
      if (!Array.isArray(attachments)) return [];
      return attachments
        .filter((a) => a && (a.url || a.name))
        .map((a) => ({ url: a.url || "", name: a.name || "" }));
    }

    function buildAttachmentsSignature(attachments) {
      const normalizedAttachments = normalizeAttachments(attachments);
      const sortedAttachments = normalizedAttachments
        .map((attachment) => ({ url: attachment.url, name: attachment.name }))
        .sort((attachmentA, attachmentB) => {
          const leftValue = `${attachmentA.url}|${attachmentA.name}`;
          const rightValue = `${attachmentB.url}|${attachmentB.name}`;
          if (leftValue < rightValue) return -1;
          if (leftValue > rightValue) return 1;
          return 0;
        });
      return JSON.stringify(sortedAttachments);
    }

    const hasValidBaseFields = computed(() =>
      Boolean(itemData.value.unit_id && itemData.value.floor_id)
    );

    const hasSectionAttachmentChanges = computed(() => {
      if (props.isAdd) return false;
      const currentSignature = buildAttachmentsSignature(
        form.value.section_attachments || []
      );
      return currentSignature !== initialSectionAttachmentsSignature.value;
    });

    const resolveIdTenant = () => {
      const unitId = itemData.value.unit_id;
      if (unitId != null) {
        const fullUnit = store.getters["unit/getItemById"](unitId);
        if (fullUnit && fullUnit.router && fullUnit.router.id_tenant != null) {
          return fullUnit.router.id_tenant;
        }
      }
      const storageTenants = store.getters["tenants_storage/getItems"] || [];
      if (
        Array.isArray(storageTenants) &&
        storageTenants.length &&
        storageTenants[0]?.id != null
      ) {
        return storageTenants[0].id;
      }
      const tenants =
        store.getters["user/getTenants"] ||
        store.getters["tenant/getSelectedItems"] ||
        [];
      const first = Array.isArray(tenants) ? tenants[0] : null;
      return first && (first.id != null || first.value != null)
        ? first.id ?? first.value
        : null;
    };

    const buildFormDataFromPayload = (payload, newFiles = [], newSectionFiles = []) => {
      const fd = new FormData();
      const existingAttachments = payload.attachments;
      const existingSectionAttachments = payload.section_attachments;
      const payloadWithoutFiles = { ...payload };
      delete payloadWithoutFiles.attachments;
      delete payloadWithoutFiles.section_attachments;
      Object.keys(payloadWithoutFiles).forEach((key) => {
        const val = payloadWithoutFiles[key];
        if (val === undefined || val === null) return;
        if (key === "comments") {
          fd.append(key, String(val ?? ""));
          return;
        }
        if (key === "brigadiers") {
          fd.append(key, JSON.stringify(val));
          return;
        }
        if (Array.isArray(val)) {
          val.forEach((v) => fd.append(`${key}[]`, v));
        } else if (typeof val === "boolean") {
          fd.append(key, val ? "1" : "0");
        } else if (typeof val === "object") {
          fd.append(key, JSON.stringify(val));
        } else {
          fd.append(key, String(val));
        }
      });
      const idTenant = resolveIdTenant();
      if (idTenant) fd.append("id_tenant", idTenant);
      if (Array.isArray(existingAttachments) && existingAttachments.length) {
        fd.append("attachments", JSON.stringify(existingAttachments));
      }
      newFiles.forEach((file) => {
        if (file instanceof File) fd.append("attachments[]", file);
      });
      if (
        Array.isArray(existingSectionAttachments) &&
        existingSectionAttachments.length
      ) {
        fd.append("section_attachments", JSON.stringify(existingSectionAttachments));
      }
      newSectionFiles.forEach((file) => {
        if (file instanceof File) fd.append("section_attachments[]", file);
      });
      return fd;
    };

    const onSubmit = async () => {
      if (!validateBranchRoles()) {
        return;
      }
      if (!validateBuildingRoles()) {
        return;
      }

      const brigadiersMapped = brigadistas.value.map((b) => ({
        floor_id: b.floor.id,
        rol_id: b.rol.value,
        user_id: b.user.value,
        training_date: b.training_date,
        training_type: b.training_type,
      }));

      const existingSectionAttachments = (form.value.section_attachments || [])
        .filter((a) => a.url || a.name)
        .map((a) => ({ url: a.url || "", name: a.name || "" }));
      const newSectionFiles = (form.value.section_attachments || [])
        .filter((a) => a.raw && a.raw instanceof File)
        .map((a) => a.raw);

      const payload = {
        unit_id: itemData.value.unit_id,
        brigadiers: brigadiersMapped,
      };

      if (!props.isAdd) {
        payload.section_attachments = existingSectionAttachments;
      }

      if (newSectionFiles.length > 0) {
        payload.section_attachments = existingSectionAttachments;
      }

      const useFormData = newSectionFiles.length > 0;

      let dispatch;
      if (useFormData) {
        const fd = buildFormDataFromPayload(payload, [], newSectionFiles);
        if (props.isAdd) {
          dispatch = store.dispatch("brigades/addWithFormData", { formData: fd });
        } else {
          dispatch = store.dispatch("brigades/editWithFormData", {
            id: itemData.value.id,
            formData: fd,
          });
        }
      } else {
        const jsonPayload = { ...payload };
        if (
          props.isAdd &&
          (!jsonPayload.section_attachments ||
            jsonPayload.section_attachments.length === 0)
        ) {
          delete jsonPayload.section_attachments;
        }

        if (props.isAdd) {
          dispatch = store.dispatch("brigades/add", jsonPayload);
        } else {
          dispatch = store.dispatch("brigades/edit", {
            id: itemData.value.id,
            params: jsonPayload,
          });
        }
      }

      dispatch
        .then((response) => {
          if (response.success) {
            toast({
              component: ToastificationContent,
              props: {
                title: response.message,
                icon: "CheckIcon",
                variant: "success",
              },
            });
            store.dispatch("unit/getAll");
            store.dispatch("brigades/getBrigadeUsers");
            emit("update:isSidebarActive", false);
            emit("refetch-data");
          } else {
            toast({
              component: ToastificationContent,
              props: {
                title: response.message,
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          }
        })
        .catch((response) => {
          let message = "Ocurrió un error inesperado";
          if (response.response?.status === 422 && response.response.data?.message) {
            message = response.response.data.message;
            if (response.response.data.users) {
              message += ": " + response.response.data.users;
            }
          } else if (response.response?.data?.message) {
            message = response.response.data.message;
          }
          toast({
            component: ToastificationContent,
            props: {
              title: message,
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        });
    };

    const validateBranchRoles = () => {
      if (!unit.value || !unit.value.category?.toLowerCase().includes("sucursal")) {
        return true;
      }

      const selectedFloor = unit.value.floors.find(f => f.id === itemData.value.floor_id);
      if (!selectedFloor || selectedFloor.headcount === 0 || !selectedFloor.is_occupied) {
        return true;
      }

      const fw = brigadistas.value.filter((b) => b.rol.code === "FW");
      const fso = brigadistas.value.find((b) => b.rol.code === "FSO");
      const sa = brigadistas.value.find((b) => b.rol.code === "SA");

      // Validar roles
      if (!fw.length || !fso || !sa) {
        toast({
          component: ToastificationContent,
          props: {
            title: "Debe existir 1 FW, 1 FSO y 1 SA",
            variant: "danger",
          },
        });
        return false;
      }

      // Validar cantidad FW
      if (fw.length !== 1) {
        toast({
          component: ToastificationContent,
          props: {
            title: "Solo se permite 1 FW en sucursal",
            variant: "danger",
          },
        });
        return false;
      }

      // Validar FSO y SA misma persona
      if (fso.user.value !== sa.user.value) {
        toast({
          component: ToastificationContent,
          props: {
            title: "FSO y SA deben ser la misma persona",
            variant: "danger",
          },
        });
        return false;
      }

      return true;
    };

    const validateBuildingRoles = () => {
      if (!unit.value || unit.value.category?.toLowerCase().includes("sucursal")) {
        return true;
      }

      const fsoList = brigadistas.value.filter((b) => b.rol.code === "FSO");
      const saList = brigadistas.value.filter((b) => b.rol.code === "SA");

      // 1 FSO obligatorio
      if (fsoList.length !== 1) {
        toast({
          component: ToastificationContent,
          props: {
            title: "Debe existir exactamente 1 FSO",
            variant: "danger",
          },
        });
        return false;
      }

      // 1 SA obligatorio
      if (saList.length !== 1) {
        toast({
          component: ToastificationContent,
          props: {
            title: "Debe existir exactamente 1 SA",
            variant: "danger",
          },
        });
        return false;
      }

      // FSO = SA
      if (fsoList[0].user.value !== saList[0].user.value) {
        toast({
          component: ToastificationContent,
          props: {
            title: "FSO y SA deben ser la misma persona",
            variant: "danger",
          },
        });
        return false;
      }

      // Validar FW por piso minimo
      //const floors = unit.value.floors || [];
      const floors = (unit.value.floors || []).filter(f => {
        return f.headcount > 0 && f.is_occupied === true;
      });

      for (const floor of floors) {
        const fwEnPiso = brigadistas.value.filter(
          (b) => b.rol.code === "FW" && b.floor?.id === floor.id
        );

        const fwCount = fwEnPiso.length;
        let requiredFW = 1;
        if (floor.headcount > 20) {
          requiredFW = 5;
        } else if (floor.headcount > 5) {
          requiredFW = 2;
        }

        // Validar (exacto requerido)
        if (fwCount < requiredFW) {
          toast({
            component: ToastificationContent,
            props: {
              title: `El piso ${floor.floor_number} requiere al menos ${requiredFW} FW (tiene ${fwCount})`,
              variant: "danger",
            },
          });
          return false;
        }
      }

      return true;
    };

    const loadData = () => {
      if (props.isAdd) {
        form.value.section_attachments = null;
        initialSectionAttachmentsSignature.value = buildAttachmentsSignature([]);
        return;
      }
      if (!props.itemEdit) {
        return;
      }
      brigadistas.value = [];
      headcount.value = null;
      itemData.value = props.itemEdit;

      const edit = props.itemEdit;
      const currentSectionAttachments = Array.isArray(edit.attachments)
        ? edit.attachments
        : edit.section_attachments;
      form.value.section_attachments = normalizeAttachments(currentSectionAttachments);
      initialSectionAttachmentsSignature.value = buildAttachmentsSignature(
        form.value.section_attachments
      );

      const unitSelected = props.unitOptions.find((u) => u.value === edit.id_unit);
      itemData.value.unit_id = edit.id_unit;

      if (edit.brigadeAssignment && edit.brigadeAssignment.length > 0 && unitSelected) {
        const firstAssignment = edit.brigadeAssignment[0];
        const floorSelected = unitSelected.floors.find(
          (f) => f.id === firstAssignment.unit_floor?.id
        );

        itemData.value.floor_id = floorSelected?.id || null;
        headcount.value = floorSelected?.headcount || null;
      } else {
        itemData.value.floor_id = null;
        headcount.value = null;
      }

      brigadistas.value = (edit.brigadeAssignment || [])
        .map((b) => {
          return {
            rol: b.brigade_role
              ? {
                  value: b.brigade_role.id,
                  label: b.brigade_role.name,
                  code: b.brigade_role.short_name,
                }
              : null,
            user: b.user_r_h
              ? { value: b.user_r_h.id, label: b.user_r_h.full_name }
              : null,
            soeid: b.user_r_h?.soeid || null,
            floor: b.unit_floor,

            assignment_date: b.assignment_date ? b.assignment_date.split(" ")[0] : null,
            assignment_status: b.assignment_status_label,
            training_date: b.brigade_training?.training_date
              ? b.brigade_training.training_date.split(" ")[0]
              : null,
            training_type: b.brigade_training?.training_type || null,
            training_status: b.training_status_label,
          };
        })
        .filter((b) => b.floor && b.floor.floor_number != null)
        .sort((a, b) => a.floor.floor_number - b.floor.floor_number);

      initialLength.value = brigadistas.value.length;
      brigadeModified.value = false;
    };

    const resetModal = () => {
      resetForm();
      itemData.value = JSON.parse(JSON.stringify(blankData));
      headcount.value = null;
      brigadistas.value = [];
      form.value.section_attachments = null;
      initialSectionAttachmentsSignature.value = buildAttachmentsSignature([]);
    };

    const t = (key, ...args) => i18n.t(key, ...args);
    const sectionAttachmentsInputRef = ref(null);
    const MAX_ATTACHMENT_SIZE_MB = 5;
    const MAX_SECTION_ATTACHMENTS = 5;
    const handleSectionAttachmentChange = (event) => {
      const files = Array.from(event.target.files || []);
      event.target.value = "";
      const currentCount = (form.value.section_attachments || []).length;
      if (currentCount >= MAX_SECTION_ATTACHMENTS) {
        toast({
          component: ToastificationContent,
          props: {
            title: t("actions.file_upload.max_documents_error", {
              n: MAX_SECTION_ATTACHMENTS,
            }),
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
        return;
      }
      const maxBytes = MAX_ATTACHMENT_SIZE_MB * 1024 * 1024;
      const validFiles = [];
      const allowedExtensions = ['pdf', 'xls', 'xlsx', 'eml'];
      for (const file of files) {
        const extension = file.name.split('.').pop().toLowerCase();
        if (!allowedExtensions.includes(extension)) {
          toast({
            component: ToastificationContent,
            props: {
              title: `El archivo ${file.name} no es válido`,
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
          continue;
        }

        if (file.size > maxBytes) {
          toast({
            component: ToastificationContent,
            props: {
              title: t("actions.file_upload.max_size_error", {
                name: file.name,
                n: MAX_ATTACHMENT_SIZE_MB,
              }),
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
          continue;
        }
        if (currentCount + validFiles.length >= MAX_SECTION_ATTACHMENTS) {
          toast({
            component: ToastificationContent,
            props: {
              title: t("actions.file_upload.max_documents_error", {
                n: MAX_SECTION_ATTACHMENTS,
              }),
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
          break;
        }
        validFiles.push(file);
      }
      if (validFiles.length === 0) return;
      const list = [...(form.value.section_attachments || [])];
      validFiles.forEach((file) => list.push({ raw: file, name: file.name || "" }));
      form.value.section_attachments = list;
    };

    const onSectionAttachmentClick = (att) => {
      if (att.url) {
        window.open(att.url, "_blank", "noopener,noreferrer");
        return;
      }
      if (att.raw || !att.url) {
        toast({
          component: ToastificationContent,
          props: {
            title: t("policy_exception.save_to_view_files"),
            icon: "InfoIcon",
            variant: "info",
          },
        });
      }
    };

    const removeSectionAttachment = (index) => {
      const list = [...(form.value.section_attachments || [])];
      list.splice(index, 1);
      form.value.section_attachments = list;
    };

    const initialLength = ref(0);
    const getUnitLabel = (unit) => {
      if (!unit) return "";
      const remsText =
        unit.rems === null || unit.rems === undefined || unit.rems === ""
          ? "No REMS"
          : `REMS: ${unit.rems}`;
      const sirhText =
        unit.sirh === null || unit.sirh === undefined || unit.sirh === ""
          ? "No SIRH"
          : `SIRH: ${unit.sirh}`;
      return `${unit.label} (${remsText}, ${sirhText})`;
    };

    const userMapperOption = (user) => ({
        value: user.id,
        label: user.full_name?.toUpperCase() + ' | ' + user.soeid,
        soeid: user.soeid,
        code_role: user.brigade_training?.role?.short_name ?? null,
        name_role: user.brigade_training?.role?.name ?? null,
        assignment_date: user.brigade_assignment?.assignment_date ?? null,
        assignment_status: user.brigade_assignment?.status_assignment ?? null,
        training_date: user.brigade_training?.training_date ?? null,
        training_type: user.brigade_training?.training_type ?? null,
        training_status: user.training_status ?? null,
      });


    return {
      userMapperOption,
      itemData,
      unit,
      brigadistas,
      editingIndex,
      tiposCapacitacion,
      form,
      fields,
      floorsOptions,
      selectFloor,
      headcount,
      roleFilter,
      searchFilter,
      floorFilter,
      filteredBrigadistas,
      submitDisabled,

      addBrigadier,
      editBrigadier,
      removeBrigadier,
      onSubmit,
      loadData,
      resetModal,
      localBrigadeUsersOptions,
      hasBrigadeChanges,
      brigadeModified,

      sectionAttachmentsInputRef,
      handleSectionAttachmentChange,
      onSectionAttachmentClick,
      removeSectionAttachment,
      maxSectionAttachments: MAX_SECTION_ATTACHMENTS,
      isSubmitDisabled,
      getUnitLabel,
    };
  },
};
</script>

<style scoped>
.attachments-upload-btn {
  position: relative;
  overflow: hidden;
}

.file-input-hidden {
  position: absolute;
  opacity: 0;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  cursor: pointer;
}

.attachments-info.file-upload-info-box {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  padding: 8px 12px;
  background: #e0f2fe;
  border-radius: 6px;
}

.attachment-preview.cursor-pointer {
  cursor: pointer;
  pointer-events: auto;
}

.attachments-info .file-upload-info-text {
  color: #0c4a6e;
  font-size: 0.875rem;
}

.attachments-info .info-icon {
  flex-shrink: 0;
  color: #0369a1;
}

.attachment-item {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
}

.attachment-name {
  max-width: 80%;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
